import { Link, useParams } from "react-router-dom";
import { modules } from "../data/modules";
import { activityRegistry } from "../activities/registry";
import { useEffect } from "react";
import { markComplete } from "../utils/progress";

export default function Activity() {
    const { activityId } = useParams();
    useEffect(() => {
        window.markComplete = markComplete;

        return () => {
            delete window.markComplete;
        };
    }, []);
    const activities = modules.flatMap(
        module => module.activities
    );
    const activity = activities.find(
        activity => activity.id === activityId
    );

    const currentIndex = activities.findIndex(
        activity => activity.id === activityId
    );

    const nextActivity =
        currentIndex >= 0
            ? activities[currentIndex + 1] ?? null
            : null;

    const previousActivity =
        currentIndex > 0
            ? activities[currentIndex - 1]
            : null;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activityId]);

    if (!activity) {
        return <h2>Activity not found</h2>;
    }

    const ActivityComponent =
        activityRegistry[activityId];
    return (
    <div
        style={{
            paddingTop: "max(20px, env(safe-area-inset-top))",
            paddingLeft: "16px",
            paddingRight: "16px",
            boxSizing: "border-box",
        }}
    >
       <div
    style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        flexWrap: "wrap",
        marginTop: "calc(env(safe-area-inset-top) + 20px)",
        marginBottom: "20px"
    }}
>
                {previousActivity && (
                    <Link to={`/activity/${previousActivity.id}`}>
                        ← Previous
                    </Link>
                )}

                <Link to="/">
                    ← Home
                </Link>

                {nextActivity && (
                    <Link to={`/activity/${nextActivity.id}`}>
                        Next →
                    </Link>
                )}
            </div>

            {ActivityComponent ? (
                <ActivityComponent title={activity.title} />
            ) : (
                <>
                    <h1>{activity.title}</h1>

                    {activity.premium && (
                        <p>⭐ Premium Activity</p>
                    )}

                    <h2>Features</h2>

                    <ul>
                        {activity.ai && <li>🤖 AI Powered</li>}
                        {activity.images && <li>🖼 Uses Images</li>}
                        {activity.audio && <li>🎧 Uses Audio</li>}
                        {activity.video && <li>🎥 Uses Video</li>}
                        {activity.model3d && <li>🧊 Uses 3D Models</li>}
                    </ul>

                    <p>Coming Soon</p>
                </>
            )}
        </div>
    );
}